/**
 * @fileoverview Exports for Student Signup page
 */

export { StudentSignup } from './StudentSignup'
